const generateScript = (id, src) => {
  if (document.getElementById(id)) {
    return;
  }
  const script = document.createElement('script');
  script.setAttribute('type', 'text/javascript');
  script.setAttribute('id', id);
  script.src = src;
  return script;
};
const append = (script) => {
  document.head.appendChild(script);
};
export default {
  appendScript(id, src) {
    append(generateScript(id, src));
  },
  appendAsyncScript(id, src) {
    let script = generateScript(id, src);
    script.async = true;
    append(script);
  },
};
